import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from './useAuth';
import { getQuota } from 'services/query';
import { displayErrorToast } from 'utils/toast';

export const useQuota = () => {
	const { t } = useTranslation();
	const { token } = useAuth();
	const [quota, setQuota] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const fetchQuota = useCallback(async () => {
		if (!token) {
			setLoading(false);
			return;
		}

		try {
			setLoading(true);
			setError(null);

			const quotaResponse = await getQuota(token);

			if (quotaResponse.errorCode) {
				displayErrorToast(quotaResponse.errorCode, t);
				setError(quotaResponse.errorCode);
			}

			setQuota(quotaResponse);
		} catch (err) {
			console.error('Error fetching quota:', err);
			setError('fetch_error');
		} finally {
			setLoading(false);
		}
	}, [token, t]);

	useEffect(() => {
		fetchQuota();
	}, [token, fetchQuota]);

	// Derived state for better performance
	const isBlocked = quota == null || quota?.remaining <= 0 || quota?.errorCode;

	return {
		quota,
		loading,
		error,
		isBlocked,
		refetch: fetchQuota,
	};
};
